import React from "react";
import { Link } from "react-router-dom";
import "../BootNavbar/Navbar.css";
import logo from "../../assets/images/logo-widetext.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faClone,
  faUsers,
  faWalking,
  faImage,
  faArrowsDownToPeople,
} from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="School Logo" className="navbar-logo" />
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsed Menu */}
        {/* <div className="collapse navbar-collapse animate-collapse" id="navbarNavDropdown"> */}
        <div className="collapse navbar-collapse animate-collapse w-100" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link
                className="nav-link" to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <FontAwesomeIcon icon={faHome} /> Home
              </Link>
            </li>
            {/* <li className="nav-item"><a href="/" className="nav-link"><FontAwesomeIcon icon={faHome} /> Home </a></li> */}

            {/* Northians Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="academicDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faClone} /> Northanian
              </Link>
              <ul className="dropdown-menu" aria-labelledby="academicDropdown">
                <li><Link className="dropdown-item" to="/aboutus" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Know About Us</Link></li>
                {/* <li><a href="/aboutus" className="dropdown-item">Know About Us</a></li> */}
                
                <li><Link className="dropdown-item" to="/chooseus" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Why To Be Northanian</Link></li>
                {/* <li><a href="/chooseus" className="dropdown-item">Why To Be Northanian</a></li> */}

                <li><Link className="dropdown-item" to="/alumni" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Northanian Alumni</Link></li>
                {/* <li><a href="/alumni" className="dropdown-item">Northanian Alumni</a></li> */}
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/facilities" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <FontAwesomeIcon icon={faArrowsDownToPeople} /> Facilities
              </Link>
            </li>
            {/* <li className="nav-item"><a href="/facilities" className="nav-link"><FontAwesomeIcon icon={faArrowsDownToPeople} /> Facilities </a></li> */}

            <li className="nav-item">
              <Link className="nav-link" to="/activities" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <FontAwesomeIcon icon={faWalking} /> Activities
              </Link>
            </li>
            {/* <li className="nav-item"><a href="/activities" className="nav-link"><FontAwesomeIcon icon={faWalking} /> Activities </a></li> */}
            

            {/* Academia Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="academiaDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faClone} /> Academia
              </Link>
              <ul className="dropdown-menu" aria-labelledby="academicDropdown">
                <li><Link className="dropdown-item" to="/staffs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Faculty & Staff</Link></li>
                {/* <li><a href="/staffs" className="dropdown-item">Faculty & Staffs</a></li> */}

                <li><Link className="dropdown-item" to="/academiccalender" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Academic Calendar</Link></li>
                {/* <li><a href="/academiccalender" className="dropdown-item">Academic Calendar</a></li> */}

                <li><Link className="dropdown-item" to="/curriculum" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Academic Curriculum</Link></li>
                {/* <li><a href="/curriculum" className="dropdown-item">Academic Curriculum</a></li> */}

                <li><Link className="dropdown-item" to="/schooluniform" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>School Uniform</Link></li>
                {/* <li><a href="/schooluniform" className="dropdown-item">School Uniform</a></li> */}

                <li><Link className="dropdown-item" to="/schoolholiday" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>School Holidays</Link></li>
              </ul>
            </li>

            {/* Admission Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="admissionDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faUsers} /> Admission
              </Link>
              <ul className="dropdown-menu" aria-labelledby="admissionDropdown">
                <li><Link className="dropdown-item" to="/regadmission" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Registration & Admission</Link></li>
                {/* <li><a href="/regadmission" className="dropdown-item">Registration & Admission</a></li> */}

                <li><Link className="dropdown-item" to="/fees" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Fees Structure</Link></li>
                {/* <li><a href="/fees" className="dropdown-item">Fees Structure</a></li> */}

                <li><Link className="dropdown-item" to="/onlineregister" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Registration</Link></li>
                {/* <li><a href="/onlineregister" className="dropdown-item">Online Registration</a></li> */}

                <li><Link className="dropdown-item" to="/downfilestype" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Download Forms & Files</Link></li>
                {/* <li><a href="/downloadfiles" className="dropdown-item">Download Forms & Documents</a></li> */}

                <li><Link className="dropdown-item" to="/admforms" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Admission Form</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/gallery" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <FontAwesomeIcon icon={faImage} /> Gallery
              </Link>
            </li>
            {/* <li className="nav-item"><a href="/gallery" className="nav-link"><FontAwesomeIcon icon={faImage} /> Gallery </a></li> */}

            {/* Contact Button */}
              {/* <button className="btn btn-primary contact-btn" to="/contactus" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Contact Us</button> */}
              {/* <a href="/contactus"><button className="btn btn-primary contact-btn" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Contact Us</button></a> */}
            <li className="nav-item">
              <Link
                className="btn btn-primary contact-btn"
                to="/contactus"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Contact Us
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;